import { render, staticRenderFns } from "./DeltaAlertOnboarding.vue?vue&type=template&id=1631208c&"
import script from "./DeltaAlertOnboarding.vue?vue&type=script&lang=js&"
export * from "./DeltaAlertOnboarding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports